import styled from "styled-components";

export interface InputBoxProps {
  $shouldRenderBox: boolean;
}

export const Box = styled.label.attrs({
  className: " rounded flex",
})<InputBoxProps>`
  border: ${(props) => (props.$shouldRenderBox ? "1px solid #ece6ee" : "none")};
  align-items: center;
  min-width: 200px;
  height: ${(props) => (props.$shouldRenderBox ? "2.5rem" : "none")};
  padding-right: ${(props) => (props.$shouldRenderBox ? "1rem" : "none")};
  padding-left: ${(props) => (props.$shouldRenderBox ? "1rem" : "none")};

  @media screen and (max-width: 768px) {
    min-width: 100px;
  }
`;

export const Input = styled.input.attrs((props) => ({
  className:
    props.type === "radio"
      ? "form-radio bg-[#3321391f] checked:bg-[#a5a6f6]"
      : "mr-5",
}))`
  border: ${(props) => (props.type === "radio" ? "2px solid #9A9A9A3D" : "")};
`;
